import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import moment from 'moment';
import { ChartSelectEvent, GoogleChartInterface } from 'ng2-google-charts';
import { BaseDialog } from "../../components/dialogs/basedialog/base.dialog";
import { Comparer } from "../../models/enums/comparer.enum";
import { DialogButton } from "../../models/enums/dialogbutton.enum";
import { monitoringChartFunctions } from "../../models/enums/monitoringchartfunctions.enum";
import { UnitType } from "../../models/enums/unittype.enum";
import { RequestColumn } from "../../models/rest/requestcolumn";
import { RequestFilter } from "../../models/rest/requestfilter";
import { RequestOptions } from "../../models/rest/requestoptions";
import { MonitoringService } from "../../services/monitoring.service";
import { SchedulerService } from "../../services/scheduler.service";
import { LogsdialogComponent } from "./logsdialog.component";

/**
 * Workflow-Log-Ansicht. Der frühere System-Tab lief über core.Logs, das der
 * DatabaseTracer/DBTracer befüllt hat — beides ist entfernt, System-Logs laufen
 * jetzt ausschliesslich über Loki. Diese Seite zeigt nur noch core.TriggerLog,
 * also Fachdaten, die der Worker schreibt.
 */
@Component({
    selector: 'logs-settings',
    templateUrl: './logs.settings.html',
    styleUrls: ['./logs.settings.css']
})
export class LogsSettings implements OnInit, AfterViewInit {

    ColumnsWorkflowTable = [
        {
            Caption: '@@ExecutionTime',
            Data: 'ExecutionTime',
            Name: 'ExecutionTime',
            IsSortable: true,
            IsFilterable: true,
            Type: 'System.DateTime',
            SearchValue: null,
            OrderState: 'NONE',
            FetchData: true,
            IsVisible: true,
            Width: {
                Type: UnitType.Pixel,
                Value: 200
            }
        },
        {
            Caption: '@@UserName',
            Data: 'UserName',
            Name: 'UserName',
            IsSortable: true,
            IsFilterable: true,
            Type: 'System.String',
            SearchValue: null,
            OrderState: 'NONE',
            FetchData: true,
            IsVisible: true,
            Width: {
                Type: UnitType.Pixel,
                Value: 200
            }
        },
        {
            Caption: '@@Name',
            Data: 'Name',
            Name: 'Name',
            IsSortable: true,
            IsFilterable: true,
            Type: 'System.String',
            SearchValue: null,
            OrderState: 'NONE',
            FetchData: true,
            IsVisible: true,
            Width: {
                Type: UnitType.Pixel,
                Value: 200
            }
        },
        {
            Caption: '@@Successfull',
            Data: 'Successfull',
            Name: 'Successfull',
            IsSortable: true,
            IsFilterable: true,
            Type: 'System.Boolean',
            SearchValue: null,
            OrderState: 'NONE',
            FetchData: true,
            IsVisible: true,
            Width: {
                Type: UnitType.Pixel,
                Value: 200
            }
        },
        {
            Caption: '@@Log',
            Data: 'Log',
            Name: 'Log',
            IsSortable: true,
            IsFilterable: true,
            Type: 'System.String',
            SearchValue: null,
            OrderState: 'NONE',
            FetchData: true,
            IsVisible: true,
            Width: {
                Type: UnitType.Pixel,
                Value: 200
            }
        }
    ];

    PieChartWorkflowType: GoogleChartInterface = {
        chartType: 'PieChart',
        dataTable: [],
        options: {
            'title': 'Workflow Count by Type',
            'height': 400
        },
    };

    PieChartWorkflowUser: GoogleChartInterface = {
        chartType: 'PieChart',
        dataTable: [],
        options: {
            'title': 'Workflow ran by user',
            'height': 400
        },
    };

    PieChartWorkflowSuccessful: GoogleChartInterface = {
        chartType: 'PieChart',
        dataTable: [],
        options: {
            'title': 'Workflow ran successful',
            'height': 400
        },
    };

    PieChartDayCountWorkflow: GoogleChartInterface = {
        chartType: 'ColumnChart',
        dataTable: [],
        options: {
            'title': 'Error count by day', 'isStacked': true,
            'height': 400
        },
    };

    RowsWorkflowTable;
    endDate = moment().endOf('day').format();
    SelectedDateWorkflows = new Date();
    SelectedDateWorkflowInvalid = false;
    LastValidSelectedWorkflowDate = new Date();

    ngOnInit(): void {
    }

    constructor(private Service: MonitoringService, private cdRef: ChangeDetectorRef, private service: SchedulerService) {
    }

    ngAfterViewInit(): void {
        this.SelectedDateWorkflows[0] = moment().startOf('day').subtract(6, 'days').toDate();
        this.SelectedDateWorkflows[1] = moment().startOf('day').toDate();

        this.LastValidSelectedWorkflowDate[0] = this.SelectedDateWorkflows[0];
        this.LastValidSelectedWorkflowDate[1] = this.SelectedDateWorkflows[1];

        const filterWorkflow = this.getTimeFilter(this.SelectedDateWorkflows[0], this.SelectedDateWorkflows[1]);

        this.refreshWorkflowTable(filterWorkflow);
        this.refreshWorkflowLogCharts(filterWorkflow);
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@Logs',
            ID: 'logs',
            Icon: 'scroll-text',
            Index: 4,
            Parent: 'about',
            Content: LogsSettings
        }
    }

    //#region Datetime Picker
    dateTimePickerWorkflowsSelectionChanged() {
        const startDate = this.returnDateStartRangePicker(this.SelectedDateWorkflows);
        const endDate = this.returnDateEndRangePicker(this.SelectedDateWorkflows);
        const filter = this.getTimeFilter(startDate, endDate);
        const numberOfDays = moment(endDate).diff(moment(startDate), 'days') + 1;

        if (numberOfDays <= 30) {
            this.LastValidSelectedWorkflowDate[0] = startDate;
            this.LastValidSelectedWorkflowDate[1] = endDate;
            this.refreshWorkflowTable(filter);
            this.refreshWorkflowLogCharts(filter);
            this.SelectedDateWorkflowInvalid = false;
        } else {
            this.SelectedDateWorkflowInvalid = true;
        }
    }

    returnDateStartRangePicker(datetimepicker) {
        return new Date(datetimepicker[0].setHours(0, 0, 0, 0));
    }

    returnDateEndRangePicker(datetimepicker) {
        return new Date(datetimepicker[1].setHours(23, 59, 59, 999));
    }
    //#endregion

    //#region onClickChartEvents
    onSelect(event: ChartSelectEvent, chart: GoogleChartInterface) {
        if (event.column == null) {
            event.column = 0;
        }
        if (event.row == null) {
            event.row = 0;
        }

        let startDate;
        let endDate;
        // Beim ungueltigen Bereich auf die letzte gueltige Auswahl zurueckfallen.
        // (Die Vorgaengerfassung hatte hier eine Zuweisung statt eines Vergleichs.)
        if (!this.SelectedDateWorkflowInvalid) {
            startDate = this.returnDateStartRangePicker(this.SelectedDateWorkflows);
            endDate = this.returnDateEndRangePicker(this.SelectedDateWorkflows);
        } else {
            startDate = this.returnDateStartRangePicker(this.LastValidSelectedWorkflowDate);
            endDate = this.returnDateEndRangePicker(this.LastValidSelectedWorkflowDate);
        }

        let value;
        const column3 = new RequestFilter();
        if (chart.chartType == "PieChart") {
            column3.Name = chart.dataTable[0][event.column];
            column3.Operator = Comparer.Equal;
            value = chart.dataTable[event.row + 1][0];
        } else if (chart.chartType == "ColumnChart") {
            const tableDate: Date = chart.dataTable[event.row + 1][0];
            startDate = new Date(tableDate.getFullYear(), tableDate.getMonth(), tableDate.getDate());
            endDate = new Date(tableDate.getFullYear(), tableDate.getMonth(), tableDate.getDate(), 23, 59, 59, 999);

            column3.Name = "Successfull";
            column3.Operator = Comparer.Equal;
            value = chart.dataTable[0][event.column];
        }
        column3.Value = value;

        const filter = this.getTimeFilter(startDate, endDate);
        filter.Filters.push(column3);

        const numberOfDays = moment(endDate).diff(moment(startDate), 'days') + 1;
        if (numberOfDays <= 30) {
            this.refreshWorkflowTable(filter);
        }
    }
    //#endregion

    //#region refresh Tables and charts
    refreshWorkflowTable(filter) {
        this.service.GetTriggerLogs(filter).subscribe((result) => {
            this.RowsWorkflowTable = result;
            if (this.cdRef) {
                this.cdRef.detectChanges();
            }
        })
    }

    refreshWorkflowLogCharts(filter) {
        this.refreshPieChart(filter, ['Name', 'Count'], this.PieChartWorkflowType, monitoringChartFunctions.CountWorkflowByType);
        this.refreshPieChart(filter, ['UserName', 'Count'], this.PieChartWorkflowUser, monitoringChartFunctions.CountWorkflowByUser);
        this.refreshPieChart(filter, ['Successfull', 'Count'], this.PieChartWorkflowSuccessful, monitoringChartFunctions.CountWorkflowSuccessful);

        this.Service.CountByDayWorkflow(filter).subscribe((result) => {
            const data = this.returnLastThirtyDaysList(this.SelectedDateWorkflows[0], this.SelectedDateWorkflows[1], result);
            this.PieChartDayCountWorkflow.dataTable = data.Data;
            const options = {
                'title': 'Error count by day',
                'isStacked': true,
                'height': 400,
                'hAxis': {
                    'ticks': data.Ticks
                }
            };
            this.PieChartDayCountWorkflow.options = options,
            this.cdRef.detectChanges();
            if (this.PieChartDayCountWorkflow.component && this.PieChartDayCountWorkflow.component.getDataTable()) {
                this.PieChartDayCountWorkflow.component.draw();
            }
        });
    }

    refreshPieChart(filter, header: any[], chart, chartFunction: monitoringChartFunctions) {
        this.Service.ExecuteChartRefresh(filter, chartFunction).subscribe((result) => {
            const list = [header];
            if (result != null) {
                result.forEach((item) => {
                    list.push([item.Key, item.Value]);
                })
            }
            chart.dataTable = list;
            this.cdRef.detectChanges();
            if (chart.component && chart.component.getDataTable()) {
                chart.component.draw();
            }
        });
    }
    //#endregion

    returnLastThirtyDaysList(date1: Date, date2: Date, result) {
        const newEndDate = new Date(date2.setHours(0, 0, 0, 0));
        const diffInDays = Math.abs(newEndDate.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24);
        const cleanedDayList: any[] = [['ExecutionTime', 'true', 'false']];
        const ticks = [];
        for (let i = diffInDays; i >= 0; i--) {
            const mom = moment(date2).startOf('day').subtract(i, 'days');
            const key = mom.format('MM/DD/YYYY');
            const existing = result.find(x => x.Key === key);
            ticks.push({ v: mom.toDate(), f: mom.format('LL') });
            if (existing) {
                cleanedDayList.push([mom.toDate(), ...existing.Value]);
            } else {
                cleanedDayList.push([mom.toDate(), 0, 0]);
            }
        }
        return {
            Ticks: ticks,
            Data: cleanedDayList
        };
    }

    getTimeFilter(dateStart, dateEnd) {
        const requestColumns = [];
        this.ColumnsWorkflowTable.forEach((col) => {
            const column = new RequestColumn();
            column.Name = col.Name;
            column.IsCommaSeparated = false;
            requestColumns.push(column);
        });

        const requestOption = new RequestOptions();

        const column = new RequestFilter();
        column.Name = "ExecutionTime";
        column.Operator = Comparer.GreaterEqual;
        column.Value = moment(dateStart).utc(true).toJSON();

        const column2 = new RequestFilter();
        column2.Name = "ExecutionTime";
        column2.Operator = Comparer.SmallerEqual;
        column2.Value = moment(dateEnd).utc(true).toJSON();

        requestOption.Columns = requestColumns;
        requestOption.Filters.push(column);
        requestOption.Filters.push(column2);
        requestOption.StartRow = null;
        requestOption.EndRow = null;

        return requestOption;
    }

    ShowDetailInfo(event) {
        BaseDialog.ShowDialog({
            ContentType: LogsdialogComponent,
            Title: '@@Details',
            Buttons: DialogButton.Cancel,
            InitArgs: event,
            Width: 600
        });
    }
}
